/**
 * A custom error class for GraphQL errors
 * It contains a code property that can be used to identify the error
 *
 * The code property comes from the `extensions.code` field in the GraphQL response
 */
export class GraphQLError extends Error {
	code?: string;
	constructor(message: string, code?: string) {
		super(message);
		this.code = code;
	}
}

export function isGraphQLError(error: unknown): error is GraphQLError {
	return error instanceof GraphQLError;
}
